export const styles = {
	container: {
		marginLeft: '10%',
	},
	accordion: {
		backgroundColor: 'transparent',
		py: 1,
	},
	accordionSummary: {
		px: 0,
		my: 1,
		borderBottom: '1px solid #45657B',
	},
	expandIcon: {
		color: '#45657B',
		fontSize: '30px',
	},
	titleTypography: {
		fontWeight: '500',
		fontSize: '18px',
	},
	contentTypography: {
		fontWeight: '400',
		fontSize: '18px',
		mb: 2,
	},
	image: {
		maxWidth: '100%',
		height: 'auto',
	},
}
